import { Dispatch, FunctionComponent, SetStateAction, useRef } from 'react'
import { Box, Typography } from '@material-ui/core'
import { AnimatedAvatar } from '../member-profile/styled'
import { OnboardingQuestion, BackendUser } from 'common/types'
import styled from 'styled-components/macro'
import { useNotification } from 'hooks/use-notification/useNotification'
//@ts-ignore
import { useTheme } from 'styled-components'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { Button } from 'common/atoms/Button/Button'


const FileNameBox = styled(Box)`
  font-size: 1em;
  color: ${props => props.theme.colors.accent1};
  padding: 0.25em;
  text-align: center;

  max-width: 15em;
  word-wrap: break-word;
`

interface AddAvatarProps {
  handleChange: Function
  getProcessedFile: Function
  questionIndex: number
  editProfileQuestions: OnboardingQuestion[]
  setProfileQuestions: Function
  user: BackendUser
  fileName: string
  setFileName: Dispatch<SetStateAction<string>>
  previewImage: string
  setPreviewImage: Function
  avatarUpdated?: boolean
  setAvatarUpdated?: Function
}

export const AddAvatar: FunctionComponent<AddAvatarProps> = ({
  handleChange,
  getProcessedFile,
  questionIndex,
  editProfileQuestions,
  setProfileQuestions,
  user,
  fileName,
  setFileName,
  previewImage,
  setPreviewImage,
  setAvatarUpdated
}) => {
  const { notify } = useNotification()
  const theme = useTheme()
  const { isDevice } = useScreenSizes()
  
  const handleUpload = (e: any) => {
    const maxImageFileSize = 5
    const files = e.target.files
    const fsMb = files[0]?.size / (1024 * 1024);
    if(fsMb > maxImageFileSize){
      notify('error', 'Upload limit for an image is 5MB');
      e.target.value=''
      setPreviewImage(user?.image)
      setAvatarUpdated(false)
      setFileName('')
      return false
    }
    getProcessedFile(files, ['jpeg', 'jpg', 'png'], 'stream', async ({ file }: any) => {
      const avatar = editProfileQuestions.find(x => x.question.includes('avatar'))
      const fileNameArray = files[0]?.name?.toLowerCase()?.split('.')
      if (avatar) {
        avatar.userAnswer = JSON.stringify({ file: file, type: fileNameArray[fileNameArray.length - 1] })
        editProfileQuestions[editProfileQuestions.indexOf(avatar)] = avatar
        setProfileQuestions([...editProfileQuestions])
      }
      setPreviewImage(URL.createObjectURL(e.target.files[0]))
      setFileName(files[0]?.name)
      setAvatarUpdated(true)
      e.target.value=''
    })
  }
  const avatar = editProfileQuestions.find(x => x.question.includes('avatar'))
  
  const clearAvatar = (e) => {
    avatar.userAnswer = ''
    setPreviewImage('https://bptn-frontend-music-dev.s3.amazonaws.com/media/images/defaultImage.png')
    editProfileQuestions[editProfileQuestions.indexOf(avatar)] = avatar
    setProfileQuestions([...editProfileQuestions])
    e.target.value=''
  }

  const hiddenFileInput = useRef(null)
  return (
    <Box>
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="flex-start">
        <Box padding="0em 1em 1em 1em">
          <AnimatedAvatar src={previewImage || user.image} alt="member with a profile" style={{ width: '4em', height: '4em' }} />
        </Box>
        <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center">
          <Button
            design='secondary'
            size={isDevice ? "small" : "medium"}
            onClick={e => {
            hiddenFileInput.current.click()
            }}
            >
            <input
            onChange={e => {
            handleUpload(e)
            handleChange(questionIndex, e)
            }}
            id="actual-btn"
            type="file"
            ref={hiddenFileInput}
            hidden
            />
            Upload Image
          </Button>
          <Box>
          {avatar?.userAnswer && avatar?.userAnswer != '' && (
          <Button
            design="tertiary"
            small
            onClick={e => {
            clearAvatar(e)
            handleChange(questionIndex, e)
            }}
            >
            Remove Image
          </Button>
            )}
          </Box>
        </Box>
      </Box>
      <Typography variant="body2">
        <FileNameBox>
          {fileName}
        </FileNameBox>
      </Typography>
    </Box>
  )
}
